import { render, staticRenderFns } from "./Layer2.vue?vue&type=template&id=ad870028&"
import script from "./Layer2.vue?vue&type=script&lang=js&"
export * from "./Layer2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports